import React from 'react';

import Head from 'next/head';

import { HOMEPAGE_TITLE, META_DESCRIPTION } from '../../constants/text';
import env from '../../env.factory';

const CANONICAL_URL = 'https://www.zillow.com/';

const HeadMetaTags: React.FC = () => {
    const { jsHost, cmsImageHost, hdpImageHost, damHost } = env;
    return (
        <Head>
            <title>{HOMEPAGE_TITLE}</title>
            <link rel="canonical" href={CANONICAL_URL} />
            <link rel="start" title="Zillow home" href="/" />
            <link rel="manifest" href="/manifest.json" />
            <link rel="preconnect" href={jsHost} />
            <link rel="preconnect" href={cmsImageHost} />
            <link rel="preconnect" href={hdpImageHost} />
            <link rel="preconnect" href={damHost} />
            <meta name="description" content={META_DESCRIPTION} />
            <meta itemProp="name" content="Zillow Real Estate, Rentals, and Mortgage" />
            <meta
                itemProp="description"
                content="The most trafficked website about home sales and rentals, with real estate values for almost every U.S. home. 1,000,000 listings that you won't find on MLS."
            />
            <meta property="og:url" content={CANONICAL_URL} />
            <meta property="og:title" content={HOMEPAGE_TITLE} />
            <meta property="og:description" content={META_DESCRIPTION} />
            <meta name="ROBOTS" content="ALL" />
            <meta name="msvalidate.01" content="D002B788494C63AC593FB8ADE2F8FB5B" />
            <meta
                name="google-site-verification"
                content="MuF3jRY3vxj9oUxkk9w1b-fm0FvR7ktG0348cGZyKtU"
            />
        </Head>
    );
};

export default HeadMetaTags;
